import { render } from "./slides_iframe_db_chap02.vue?vue&type=template&id=e1873976&scoped=true"
import script from "./slides_iframe_db_chap02.vue?vue&type=script&lang=js"
export * from "./slides_iframe_db_chap02.vue?vue&type=script&lang=js"

import "./slides_iframe_db_chap02.vue?vue&type=style&index=0&id=e1873976&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1873976"]])

export default __exports__